module.exports = __webpack_public_path__ + "static/logo-42423d73883b1742435a8d3e8816bac1.png";